import { render } from "./secstudentsprocessed.vue?vue&type=template&id=552e781b&scoped=true"
import script from "./secstudentsprocessed.vue?vue&type=script&lang=js"
export * from "./secstudentsprocessed.vue?vue&type=script&lang=js"

import "./secstudentsprocessed.vue?vue&type=style&index=0&id=552e781b&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552e781b"]])

export default __exports__